<template>

  <section class="page-container">
    <div class="banner-container">
      <img
    src="https://loyalty.elevatozrewards.com/wp-content/uploads/2025/09/tc_banner.png"        alt="Centuary Mattresses Banner"
        class="responsive-banner"
      />
    </div>

    <div class="button-container">
      <button class="btn btn-proceed" @click="goToTerms">
        Continue
      </button>
    </div>

    <div class="footer">
      Powered by Elevatoz PVT LTD
    </div>
  </section>
</template>

<script>
export default {
  name: "HomePageDesign",
  methods: {
    goToTerms() {
      // emit an event to parent to change page
      this.$emit("validated"); 
    },
  },
};
</script>

<style scoped>
.page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f0f2f5;
  min-height: 100vh;
  padding: 16px 16px 8px; /* reduce bottom padding */
  box-sizing: border-box;
  justify-content: flex-start; /* keep content at top */
}

.banner-container {
  width: 100%;
  max-width: 420px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 0px 14px 0px #00000059;
  margin-bottom: 12px; /* smaller gap before button */
}

.responsive-banner {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

.button-container {
  width: 280px;
  margin-bottom: 16px; /* keep button closer to footer */
}

.footer {
  margin-top: auto; /* pushes footer to bottom of screen */
  font-size: 0.6rem;
  color: #888;
  text-align: center;
}

.btn-proceed {
  width: 100%;
  height: 46px;
  background-color: #004053;
  color: white;
  border: 1px solid #004053;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}



/* 
.footer {
  margin-top: 32px;
  font-size: 0.6rem;
  color: #888;
  text-align: center;
} */

@media (max-width: 400px) {
  .banner-container {
    max-width: 100%;
    height: 500px;
  }

  .button-container {
    width: 80%;
  }
}

@media (max-width: 320px) {
  .banner-container {
    height: 450px;
  }

  .button-container {
    width: 90%;
  }
}
</style>
